import { resolveOrderId } from "./resolve-order-id";

export type DashboardNoticeKind = "rescheduled" | "cancelled";

/** A success banner the dashboard shows for the order a mutation just changed. */
export interface DashboardNotice {
  kind: DashboardNoticeKind;
  orderNumber: string;
}

const NOTICE_KINDS: readonly DashboardNoticeKind[] = [
  "rescheduled",
  "cancelled",
];

/**
 * Reschedule/cancel succeed on the order page (or a dashboard row) and then
 * land on the dashboard, so the confirmation travels in the query string —
 * `?rescheduled=<order>` / `?cancelled=<order>` — rather than in client
 * state that the navigation would drop. Only a well-formed SAP order number
 * is accepted; anything else renders no banner.
 */
export function readDashboardNotice(
  searchParams: Record<string, string | undefined>,
): DashboardNotice | null {
  for (const kind of NOTICE_KINDS) {
    const value = searchParams[kind];
    if (!value) continue;
    const resolved = resolveOrderId(value);
    if (resolved.kind === "orderNumber") {
      return { kind, orderNumber: resolved.orderNumber };
    }
  }
  return null;
}

/** Public dashboard path carrying a notice (the wgl rewrite maps it to /f/appointment). */
export function dashboardNoticeHref(
  kind: DashboardNoticeKind,
  orderNumber: string,
): string {
  return `/appointment?${kind}=${encodeURIComponent(orderNumber)}`;
}
